export default "__VITE_ASSET__CQ4SVphK__"